<template>
    <main>
        <OrderListDetails></OrderListDetails>
        <div class="all-sections">
            <Timeline></Timeline>
            <OrderMessage :currencyBrand="orderData.currency" :dataComments="orderData.orderHistories"></OrderMessage>
        </div>
    </main>
</template>

<script>
import OrderListDetails from "./OrderListDetails";
import Timeline from "./Timeline";
import OrderMessage from "./OrderMessage";

export default {
    name: "Main",
    props: ["orderData"],
    data() {
        return {
            messageOrder: []
        };
    },
    components: {
        OrderMessage,
        OrderListDetails,
        Timeline
    },
    created() {}
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

main {
    @extend %primary-background;
    border: 1px solid $color4;
    @media only screen and (max-width: 767px) {
        margin-bottom: 15px;
    }
    .all-sections {
        padding: 0 20px 20px 20px;
    }
}
</style>



// WEBPACK FOOTER //
// OrderMain.vue?1e372590